<button type="submit" (click)="buttonClickedFn()" [disabled]="disabled" class="bg-[var(--secondary-color)] rounded-3xl w-[20px] h-[20px] text-white flex items-center outline-none justify-center disabled:opacity-20">
    <ng-content/>
</button>